import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { string, number, func, object, array, bool } from 'prop-types';

import './ExpandableContent.scss';
ExpandableContent.propTypes = {
  defaultExpanded: bool,
  headerText: string,
  children: array,
  maxHeight: number,
  headerTestId: string,
  className: string
};

ExpandableContent.defaultProps = {
  headerText: 'Expand'
};

export default function ExpandableContent(props) {
  const { defaultExpanded, headerText, headerTestId, children, maxHeight, className } = props;
  const [expanded, setExpanded] = useState(defaultExpanded);
  const [showOverflow, setShowOverflow] = useState(defaultExpanded);
  const [isExpanding, setIsExpanding] = useState(false);
  function toggleExpanded() {
    if (isExpanding) {
      return;
    }
    if (!expanded) {
      setIsExpanding(true);
      setTimeout(() => {
        setShowOverflow(true);
        setIsExpanding(false);
      }, 700);
    } else {
      setShowOverflow(false);
    }
    setExpanded(!expanded);
  }

  return (
    <div className={classnames(className, 'expandable-content__header')}>
      <div className={classnames('top-bar', { expanded })} data-test-id={headerTestId} onClick={toggleExpanded}>
        <span className="span--top-bar">{headerText}</span>
        <i
          className={classnames('expandable-content__header-arrow icon-down-open', {
            expanded
          })}
        />
      </div>
      <div className={classnames('stat__group-container', { expanded, visible: showOverflow })} style={{ maxHeight }}>
        {children}
      </div>
    </div>
  );
}

ExpandableContentSection.propTypes = {
  children: array,
  className: string,
  hideBorder: bool
};
export function ExpandableContentSection(props) {
  const { children, className, hideBorder } = props;
  return <div className={classnames(className, 'stat__group-row', { 'no-border': hideBorder })}>{children}</div>;
}
